import { render, staticRenderFns } from "./TabBarIcon.vue?vue&type=template&id=9917d622&scoped=true"
import script from "./TabBarIcon.vue?vue&type=script&lang=js"
export * from "./TabBarIcon.vue?vue&type=script&lang=js"
import style0 from "./TabBarIcon.vue?vue&type=style&index=0&id=9917d622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9917d622",
  null
  
)

export default component.exports